/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  contextualFooter module
 */

import { filterActions } from '@zumper/redux-ignore'

import { default as rootReducer } from './reducers/index'
import { default as whitelist } from './reducers/whitelist'

export { whitelist }
export default filterActions(rootReducer, whitelist)
